export { autoTextSize, updateTextSize } from "./auto-text-size-standalone";
export { AutoTextSize } from "./auto-text-size-react";
//# sourceMappingURL=index.js.map